// Canonical production URL used in SEO meta + JSON-LD.
// Override via REACT_APP_SITE_URL if rendering on a non-production domain.
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://www.zozoventure.com"
).replace(/\/$/, "");
